
import React from 'react';
import { Card, Placeholder, Spinner } from 'react-bootstrap';
import './ComponentSkeleton.css';

const ComponentSkeleton = ({ type, count = 3 }) => {
    const skeletons = {
        chart: (
            <Card className="h-100">
                <Card.Header>
                    <Placeholder as="div" animation="glow">
                        <Placeholder xs={4} bg="secondary" />
                    </Placeholder>
                </Card.Header>
                <Card.Body className="d-flex justify-content-center align-items-center">
                    <div className="skeleton-chart" />
                </Card.Body>
            </Card>
        ),
        
        table: (
            <Card>
                <Card.Header>
                    <Placeholder as="div" animation="glow">
                        <Placeholder xs={6} bg="secondary" />
                    </Placeholder>
                </Card.Header>
                <Card.Body>
                    {/* Header de tabla */}
                    <div className="skeleton-table-header mb-3">
                        <Placeholder as="div" animation="glow" className="d-flex">
                            <Placeholder xs={3} className="me-2" />
                            <Placeholder xs={2} className="me-2" />
                            <Placeholder xs={3} className="me-2" />
                            <Placeholder xs={2} className="me-2" />
                            <Placeholder xs={2} />
                        </Placeholder>
                    </div>
                    
                    {/* Filas de tabla */}
                    {[...Array(count)].map((_, i) => (
                        <div key={i} className="skeleton-table-row mb-2">
                            <Placeholder as="div" animation="glow" className="d-flex">
                                <Placeholder xs={3} className="me-2" />
                                <Placeholder xs={2} className="me-2" />
                                <Placeholder xs={3} className="me-2" />
                                <Placeholder xs={2} className="me-2" />
                                <Placeholder xs={2} />
                            </Placeholder>
                        </div>
                    ))}
                </Card.Body>
            </Card>
        ),
        
        map: (
            <Card>
                <Card.Header>
                    <Placeholder as="div" animation="glow">
                        <Placeholder xs={4} bg="info" />
                    </Placeholder>
                </Card.Header>
                <Card.Body>
                    <div className="skeleton-map" style={{ height: '300px', backgroundColor: '#f8f9fa', borderRadius: '8px', position: 'relative' }}>
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <div className="text-center">
                                <Spinner animation="border" variant="info" size="sm" />
                                <div className="mt-2">
                                    <Placeholder as="div" animation="glow">
                                        <Placeholder xs={8} bg="info" />
                                    </Placeholder>
                                </div>
                            </div>
                        </div>
                        {/* Simular marcadores del mapa */}
                        <div className="position-absolute" style={{ top: '20%', left: '30%', width: '8px', height: '8px', backgroundColor: '#dc3545', borderRadius: '50%' }}></div>
                        <div className="position-absolute" style={{ top: '60%', left: '70%', width: '8px', height: '8px', backgroundColor: '#ffc107', borderRadius: '50%' }}></div>
                        <div className="position-absolute" style={{ top: '40%', left: '50%', width: '8px', height: '8px', backgroundColor: '#28a745', borderRadius: '50%' }}></div>
                    </div>
                </Card.Body>
            </Card>
        ),
        frequency: (
            <Card className="h-100">
                <Card.Header>
                    <Placeholder as="div" animation="glow">
                        <Placeholder xs={5} bg="warning" />
                    </Placeholder>
                </Card.Header>
                <Card.Body className="d-flex justify-content-center align-items-center">
                    <div className="skeleton-frequency">
                        {/* Simular gráfico de barras */}
                        <div className="d-flex align-items-end justify-content-around" style={{ height: '200px', gap: '8px' }}>
                            {[...Array(7)].map((_, i) => (
                                <div 
                                    key={i}
                                    className="skeleton-bar"
                                    style={{
                                        width: '20px',
                                        height: `${Math.random() * 150 + 50}px`,
                                        backgroundColor: '#ffc107',
                                        opacity: 0.3,
                                        borderRadius: '4px 4px 0 0',
                                        animation: `pulse 1.5s ease-in-out ${i * 0.2}s infinite alternate`
                                    }}
                                />
                            ))}
                        </div>
                        
                        {/* Etiquetas inferiores */}
                        <div className="mt-3">
                            <Placeholder as="div" animation="glow" className="d-flex justify-content-around">
                                {[...Array(7)].map((_, i) => (
                                    <Placeholder key={i} xs={1} bg="warning" />
                                ))}
                            </Placeholder>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        )
    };
    
    return skeletons[type] || <div className="skeleton-default" />;
};

export default ComponentSkeleton;